define(function() {
	const IpsModel = require('civicsBase/ipsModel');
	
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/portal/users/mfasubscriptions/',
		url: function() {
			let base = this.urlRoot;

            if (this.subscriptionId) {
                base += this.subscriptionId;
            }

            if (this.setPriority === true) {
                base += '/priority';
            }

            return base;
		},
	});
});